import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-strong-authentication',
  templateUrl: './strong-authentication.component.html',
  styleUrls: ['./strong-authentication.component.scss'],
})
export class StrongAuthenticationComponent implements OnInit {

  public error: GlobalErrorHandlerService = null;

  public confirmAuth: boolean = false;
  public confirmAuthSaved: boolean = false;
  public updateDisabled: boolean = true;
  public didResendPin: boolean = false;
  public resendDisabled: boolean = false;
  public customer: CustomerModel;
  public strongAuthImage = null;
  public showStrongAuthWithMFA: boolean;
  public showStrongAuthWithPIN: boolean;
  public isShowStrongMFAEnabled: boolean = false;
  constructor(
      public navigator: Navigator,
      public platform: Platform,
      public authenticationService: AuthenticationService,
      public successMessageService: SuccessMessageService,
      public responsibleService: ResponsibleGamingService,
      public userSession: UserSessionService,
      public configService: ConfigService,
      private utils: UtilsService) {

      this.showStrongAuthWithMFA = this.configService.getConfig().FEATURE_SHOW_STRONG_AUTH_WITH_MFA === '1' ? true : false;
      this.showStrongAuthWithPIN = this.configService.getConfig().FEATURE_SHOW_STRONG_AUTH_WITH_PIN === '1' ? true : false; 
      
      this.successMessageService.clearMessage();

      this.userSession.getCustomer().subscribe(
          (customer) => {
          if (customer) {
            this.customer = customer;
            if (this.showStrongAuthWithPIN) {
              const confirmAuthKey = this.customer.customData.filter(x => { return x.key === "CONFIRM_AUTH" })[0];
              if (confirmAuthKey) {
                const keyValueFlag = confirmAuthKey.value;

                if (keyValueFlag != "0") {
                  this.confirmAuth = true;
                  this.confirmAuthSaved = true;
                }
                else {
                  this.confirmAuth = false;
                  this.confirmAuthSaved = false;
                }
              }
            }

            if (this.showStrongAuthWithMFA) {
              const confirmAuthKey = this.customer.customData.filter(x => { return x.key === "REQUIRED_MFA" })[0];
              if (confirmAuthKey) {
                const keyValueFlag = confirmAuthKey.value;

                if (keyValueFlag == "true") {
                  this.confirmAuth = true;
                }
                else {
                  this.confirmAuth = false;
                }

              }
            }
            const currentMFAMethod = this.customer.customData.filter(x => { return x.key === "MFA_METHOD" })[0].value==="SMS";
            this.isShowStrongMFAEnabled=!currentMFAMethod;
          }
        }
      );
  }

  ngOnInit() {
    if (this.showStrongAuthWithMFA){
      this.setDefaultImage();
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
  }

  setDefaultImage() {
    //this.strongAuthImage = this.utils.getCDNAsset("imgs/strongauthlock.png");
    this.strongAuthImage = '../../../assets/images/strongauthlock.png'
  }

  onUpdateStrongAuth() {
    this.successMessageService.clearMessage();
    this.updateDisabled = false;
  }

  onSetStrongAuthUSA() {
    this.confirmAuth = !this.confirmAuth
    const data: any = [];
    if (this.confirmAuth == true) {
      data['propName'] = "REQUIRED_MFA";
      data['propValue'] = true;
    }
    else {
      data['propName'] = "REQUIRED_MFA";
      data['propValue'] = false;
    }
    this.authenticationService.updateCustomData(data).subscribe({
      next:() => {
      this.userSession.refreshCustomer();
    },error: (error) => {
      error.setErrorMessage('There was an issue trying to update MFA settings. Please contact customer support.');
      this.error = error;
    }
  });
  }

  onSetStrongAuthON() {
    let confirmAuthObj = {};

    if (this.confirmAuth == true) {
      confirmAuthObj = { "confirmAuth": 1 };
    }
    else {
      confirmAuthObj = { "confirmAuth": 0 };
    }

    this.authenticationService.callConfirmAuth(confirmAuthObj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          if (this.confirmAuth == true) {
            this.successMessageService.setMessage("Strong authentication has been successfully enabled.");
          }
          else {
            this.successMessageService.setMessage("Strong authentication was successfully disabled.");
          }

          this.userSession.refreshCustomer();

          this.updateDisabled = true;
        }
      },
      error: (error) => {
        error.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.error = error;
      }
    });
  }

  onResendPIN() {
    this.successMessageService.clearMessage();
    this.error = null;

    this.resendDisabled = true;
    //call service here when it is available.
    this.responsibleService.callResendPin().subscribe({
     next: (response) => {
        if (response.result == 1) {
          this.successMessageService.setMessage("We have sent your Personal Identification Number (PIN) to your email address.");
        }
      },
     error: (error) => {
        error.setErrorMessage('There was an issue trying to send your Personal Identification Number (PIN) to your email address. Please contact customer support.');
        this.error = error;
      }
    });
  }

  closeModal = () => {
      this.navigator.navigateTo("LogoutPage", { forceModal: true }, {reason:'STRONG_AUTH_EXIT'});
  }
}
